export const myQRcontainer = {
  display: 'grid',
  gridTemplateRows: 'auto auto 1fr auto',
  width: '100%',
  height: '100vh',
  padding: '20px 0 0 0',

  '@media (max-width: 1024px)': {
    height: 'auto',
    padding: '16px 16px 70px',
  },
};

export const myQrTopCard = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '17px 10px 17px 40px',
  background: 'var(--white)',
  borderRadius: '20px',
  marginBottom: '24px',
  boxShadow: '0px 0px 20px 0px #0000000d',
  marginRight: '20px',

  '@media (min-width: 769px)': {
    padding: '17px 40px',
  },

  '@media (max-width: 1024px)': {
    marginRight: '0',
  },
};

export const button = {
  gap: '8px',
  padding: '8px 24px',
  textTransform: 'capitalize',
  borderRadius: '8px',
  background: 'linear-gradient(90deg, var(--blue600) 0%, var(--blue300) 100%)',
  color: 'var(--white)',
  fontWeight: 600,
  fontSize: '18px',
};

export const activateBtn = {
  background: 'var(--white)',
  color: 'var(--primary)',
  fontWeight: '500',
  fontSize: '15px',
  padding: '4px 20px',
  borderRadius: '20px',

  '&.expired-btn': {
    color: 'var(--darkRed)',
  },
};
